import React from "react";
import ReactDOM from "react-dom/client";
import "./global.css";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";

import Routers from "../src/Routers/Routers";
// import reportWebVitals from './reportWebVitals';
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Nao recarregar os dados ao voltar o foco pra janela
      // (evita perder o que nao foi salvo ao trocar de tela/planilha)
      refetchOnWindowFocus: false,
    },
  },
});

// Impede que rolar o mouse sobre um campo numerico altere o valor sem querer
if (typeof document !== "undefined") {
  document.addEventListener(
    "wheel",
    () => {
      const el = document.activeElement;
      if (el && el.tagName === "INPUT" && el.type === "number") {
        el.blur();
      }
    },
    { passive: true }
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Routers />
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
